export enum EMtype {
  /** 美式橄榄球让球 */
  Mty6001 = 6001,
  /** 美式橄榄球大小 */
  Mty6002 = 6002,
  /** 美式橄榄球胜负 */
  Mty6003 = 6003,
  /** 美式橄榄球主队大小 */
  Mty6004 = 6004,
  /** 美式橄榄球客队大小 */
  Mty6005 = 6005,
  /** 美式橄榄球单双 */
  Mty6006 = 6006,
  /** 美式橄榄球主队单双 */
  Mty6007 = 6007,
  /** 美式橄榄球客队单双 */
  Mty6008 = 6008,
  /** 美式橄榄球独赢(三项) */
  Mty6009 = 6009,
  /** 美式足球平局退款 */
  Mty6010 = 6010,
  /** 美式橄榄球是否有加时 */
  Mty6011 = 6011,
  /** 美式橄榄球最高得分节 */
  Mty6012 = 6012,
  /** 美式橄榄球最高得分半场 */
  Mty6013 = 6013,
  /** 美式橄榄球最先到达x分 */
  Mty6014 = 6014,
  /** 美式橄榄球半/全场 */
  Mty6015 = 6015,
  /** 美式橄榄球达阵大小 */
  Mty6016 = 6016,
  /** 美式橄榄球射门大小 */
  Mty6017 = 6017,
  /** 美式橄榄球第x个射门球队 */
  Mty6018 = 6018,
  /** 美式橄榄球下一个得分的球队 */
  Mty6019 = 6019,
  /** 美式橄榄球下一个得分类型 */
  Mty6020 = 6020,
  /** 美式足球冠军赛事冠军 */
  Mty6999 = 6999,
  /** 美式足球冠军赛事冠军 */
  Mty6998 = 6998,
  /** 美式足球亚足联会议获胜者 */
  Mty6997 = 6997,
  /** 美式足球NFC会议获胜者 */
  Mty6996 = 6996,
  /** 美式足球亚足联分区东部冠军 */
  Mty6995 = 6995,
  /** 美式足球亚足联分区南冠军 */
  Mty6994 = 6994,
  /** 美式足球亚足联西区冠军 */
  Mty6993 = 6993,
  /** 美式足球亚足联赛区北冠军 */
  Mty6992 = 6992,
  /** 美式足球NFC 部门东部冠军 */
  Mty6991 = 6991,
  /** 美式足球NFC 部门南优胜者 */
  Mty6990 = 6990,
  /** 美式足球NFC 部门西部冠军 */
  Mty6989 = 6989,
  /** 美式足球NFC 部门北获胜者 */
  Mty6988 = 6988,
  /** 美式足球获胜联盟 */
  Mty6987 = 6987,
  /** 美式足球获胜赛区 */
  Mty6986 = 6986,
  /** 亚运会冠军赛事冠军 */
  Mty101998 = 101998,
  /** 亚运会冠军赛事冠军 */
  Mty101999 = 101999,
  /** 羽毛球 独赢（两项） */
  Mty47001 = 47001,
  /** 羽毛球 让分 */
  Mty47002 = 47002,
  /** 羽毛球 总分大小分 */
  Mty47003 = 47003,
  /** 羽毛球 正确比分(BO3) */
  Mty47004 = 47004,
  /** 羽毛球 正确比分(BO5) */
  Mty47005 = 47005,
  /** 羽毛球 局独赢 */
  Mty47006 = 47006,
  /** 羽毛球 局单双 */
  Mty47007 = 47007,
  /** 羽毛球 局内第X分的球队 */
  Mty47008 = 47008,
  /** 羽毛球冠军赛事冠军 */
  Mty47999 = 47999,
  /** 羽毛球冠军赛事冠军 */
  Mty47998 = 47998,
  /** 棒球让分 */
  Mty7001 = 7001,
  /** 棒球大小分 */
  Mty7002 = 7002,
  /** 棒球独赢（两项） */
  Mty7003 = 7003,
  /** 棒球主队大小分 */
  Mty7004 = 7004,
  /** 棒球客队大小分 */
  Mty7005 = 7005,
  /** 棒球独赢（三项） */
  Mty7006 = 7006,
  /** 棒球单双 */
  Mty7007 = 7007,
  /** 棒球剩余时间获胜 */
  Mty7008 = 7008,
  /** 棒球是否有加时 */
  Mty7009 = 7009,
  /** 棒球胜分差 */
  Mty7010 = 7010,
  /** 棒球安打大小分 */
  Mty7011 = 7011,
  /** 棒球本垒打大小分 */
  Mty7012 = 7012,
  /** 棒球独赢（两项） */
  Mty7013 = 7013,
  /** 棒球独赢&大小 */
  Mty7014 = 7014,
  /** 棒球先得X分的队伍 */
  Mty7016 = 7016,
  /** 棒球主队安打大小分 */
  Mty7017 = 7017,
  /** 棒球客队安打大小分 */
  Mty7018 = 7018,
  /** 棒球最高得分局 */
  Mty7019 = 7019,
  /** 棒球冠军赛事冠军 */
  Mty7999 = 7999,
  /** 棒球冠军赛事冠军 */
  Mty7998 = 7998,
  /** 棒球冠军赛事美國聯盟冠军 */
  Mty7997 = 7997,
  /** 棒球冠军赛事國家聯盟冠军 */
  Mty7996 = 7996,
  /** 棒球冠军赛事美國聯盟中區冠军 */
  Mty7995 = 7995,
  /** 棒球冠军赛事美國聯盟東區冠军 */
  Mty7994 = 7994,
  /** 棒球冠军赛事美國聯盟西區冠军 */
  Mty7993 = 7993,
  /** 棒球冠军赛事國家聯盟中區冠军 */
  Mty7992 = 7992,
  /** 棒球冠军赛事國家聯盟東區冠军 */
  Mty7991 = 7991,
  /** 棒球冠军赛事國家聯盟西區冠军 */
  Mty7990 = 7990,
  /** 篮球胜平负（3項） */
  Mty3001 = 3001,
  /** 篮球让分 */
  Mty3002 = 3002,
  /** 篮球总分大小 */
  Mty3003 = 3003,
  /** 篮球独赢（2項） */
  Mty3004 = 3004,
  /** 篮球单双 */
  Mty3005 = 3005,
  /** 篮球欧盘让分(已删除) */
  Mty3006 = 3006,
  /** 篮球胜分差（选项 主胜1-5，主胜6-10，主胜11-15，主胜16-20，主胜21-25，主胜26+，客胜1-5，客胜6-10，客胜11-15，客胜16-20，客胜21-25，客胜26+） */
  Mty3007 = 3007,
  /** 篮球首次达到x分球队 */
  Mty3008 = 3008,
  /** 篮球主队总分大小 */
  Mty3012 = 3012,
  /** 篮球客队总分大小 */
  Mty3013 = 3013,
  /** 篮球独赢和大小 */
  Mty3014 = 3014,
  /** 篮球会有加时 */
  Mty3015 = 3015,
  /** 篮球最高得分的节 */
  Mty3016 = 3016,
  /** 篮球半/全场胜平负（常规时间） */
  Mty3017 = 3017,
  /** 独赢（两项） */
  Mty3020 = 3020,
  /** 篮球最后一分的球队 */
  Mty3021 = 3021,
  /** 篮球主队总得分单双 */
  Mty3022 = 3022,
  /** 篮球客队总得分单双 */
  Mty3023 = 3023,
  /** 篮球全场大小（包含精确） */
  Mty3026 = 3026,
  /** 篮球单节胜分差 */
  Mty3027 = 3027,
  /** 篮球半/全场(包含加时) */
  Mty3028 = 3028,
  /** 篮球单节首次到达x分的球队 */
  Mty3029 = 3029,
  /** 篮球第x分的得分类型 */
  Mty3030 = 3030,
  /** 篮球任意球队第X分的得分类型 */
  Mty3031 = 3031,
  /** 篮球第X分的球队 */
  Mty3032 = 3032,
  /** 篮球最高得分半场 */
  Mty3033 = 3033,
  /** 篮球第x个暂停球队 */
  Mty3034 = 3034,
  /** 篮球第x个罚球得分球队 */
  Mty3035 = 3035,
  /** 篮球哪对赢得争球 */
  Mty3036 = 3036,
  /** 篮球得分最后一位数 */
  Mty3037 = 3037,
  /** 篮球主队得分最后一位数 */
  Mty3038 = 3038,
  /** 篮球得分最后一位数 */
  Mty3039 = 3039,
  /** 篮球单节单双组合 */
  Mty3040 = 3040,
  /** 篮球让分大小组合 */
  Mty3041 = 3041,
  /** 篮球主客队尾数组合 */
  Mty3042 = 3042,
  /** 篮球冠军赛事动态玩法 */
  Mty3999 = 3999,
  /** 篮球系列赛冠军 */
  Mty3900 = 3900,
  /** 篮球系列赛让分 */
  Mty3901 = 3901,
  /** 篮球系列赛正确比分 */
  Mty3902 = 3902,
  /** 篮球常规赛胜利 */
  Mty3903 = 3903,
  /** 篮球是否进入季后赛 */
  Mty3904 = 3904,
  /** 篮球系列赛第几场结束 */
  Mty3905 = 3905,
  /** 篮球系列赛第三场比赛后比分 */
  Mty3906 = 3906,
  /** 篮球系列赛第四场比赛后比分 */
  Mty3907 = 3907,
  /** 篮球冠军赛事动获胜者 */
  Mty3998 = 3998,
  /** 篮球冠军赛事A组前2名球队 */
  Mty3997 = 3997,
  /** 篮球冠军赛事A组前3名球队 */
  Mty3996 = 3996,
  /** 篮球冠军赛事A组前4名球队 */
  Mty3995 = 3995,
  /** 篮球冠军赛事A组胜者 */
  Mty3994 = 3994,
  /** 篮球冠军赛事B组胜者 */
  Mty3993 = 3993,
  /** 篮球冠军赛事C组胜者 */
  Mty3992 = 3992,
  /** 篮球冠军赛事D组胜者 */
  Mty3991 = 3991,
  /** 篮球冠军赛事E组胜者 */
  Mty3990 = 3990,
  /** 篮球冠军赛事F组胜者 */
  Mty3989 = 3989,
  /** 篮球冠军赛事G组胜者 */
  Mty3988 = 3988,
  /** 篮球冠军赛事H组胜者 */
  Mty3987 = 3987,
  /** 篮球冠军赛事西部冠军 */
  Mty3986 = 3986,
  /** 篮球冠军赛事东部冠军 */
  Mty3985 = 3985,
  /** 篮球冠军赛事中部冠军 */
  Mty3984 = 3984,
  /** 篮球冠军赛事西南南冠军 */
  Mty3983 = 3983,
  /** 篮球冠军赛事东南冠军 */
  Mty3982 = 3982,
  /** 篮球冠军赛事西北冠军 */
  Mty3981 = 3981,
  /** 篮球冠军赛事太平洋区冠军 */
  Mty3980 = 3980,
  /** 篮球冠军赛事大西洋区冠军 */
  Mty3979 = 3979,
  /** 篮球冠军赛事年度最佳教练 */
  Mty3978 = 3978,
  /** 篮球冠军赛事年度最佳防守球员 */
  Mty3977 = 3977,
  /** 篮球冠军赛事Regular Season */
  Mty3976 = 3976,
  /** 篮球冠军赛事年度最佳新秀 */
  Mty3975 = 3975,
  /** 篮球冠军赛事最具进步的球员 */
  Mty3974 = 3974,
  /** 篮球冠军赛事年度最佳第六人奖 */
  Mty3973 = 3973,
  /** 篮球冠军赛事年度最佳第六人奖 */
  Mty3971 = 3971,
  /** 篮球冠军赛事常规赛每场篮板数冠军 */
  Mty3970 = 3970,
  /** 篮球冠军赛事年度常规赛每场得分领先者 */
  Mty3969 = 3969,
  /** 篮球冠军赛事常规赛每场助攻王 */
  Mty3968 = 3968,
  /** 篮球冠军赛事常规赛冠军 */
  Mty3967 = 3967,
  /** 篮球冠军赛事总决赛MVP */
  Mty3966 = 3966,
  /** 篮球获胜联盟 */
  Mty3965 = 3965,
  /** 篮球获胜赛区 */
  Mty3964 = 3964,
  /** 篮球第一二名预测 */
  Mty3963 = 3963,
  /** 篮球I组冠军 */
  Mty3962 = 3962,
  /** 篮球J组冠军 */
  Mty3961 = 3961,
  /** 篮球K组冠军 */
  Mty3960 = 3960,
  /** 篮球L组冠军 */
  Mty3959 = 3959,
  /** 篮球M组冠军 */
  Mty3958 = 3958,
  /** 篮球N组冠军 */
  Mty3957 = 3957,
  /** 篮球O组冠军 */
  Mty3956 = 3956,
  /** 篮球P组冠军 */
  Mty3955 = 3955,
  /** 沙滩排球独赢（两项） */
  Mty51001 = 51001,
  /** 沙滩排球让分 */
  Mty51002 = 51002,
  /** 沙滩排球大小分 */
  Mty51003 = 51003,
  /** 沙滩排球正确比分(BO5) */
  Mty51004 = 51004,
  /** 沙滩排球正确比分(BO3) */
  Mty51005 = 51005,
  /** 沙滩排球局独赢 */
  Mty51006 = 51006,
  /** 沙滩排球单双 */
  Mty51007 = 51007,
  /** 沙滩排球冠军赛事冠军 */
  Mty51999 = 51999,
  /** 沙滩排球冠军赛事冠军 */
  Mty51998 = 51998,
  /** BOWLS冠军赛事冠军 */
  Mty21999 = 21999,
  /** 保龄球冠军赛事冠军 */
  Mty21998 = 21998,
  /** 拳击大小 */
  Mty19001 = 19001,
  /** 拳击独赢（两项） */
  Mty19002 = 19002,
  /** 拳击是否会奋战到底 */
  Mty19003 = 19003,
  /** 拳击获胜方式 */
  Mty19004 = 19004,
  /** 拳击冠军赛事冠军 */
  Mty19999 = 19999,
  /** 拳击冠军赛事冠军 */
  Mty19998 = 19998,
  /** 板球独赢(胜平负) */
  Mty14001 = 14001,
  /** 板球独赢 */
  Mty14002 = 14002,
  /** 板球大小 */
  Mty14003 = 14003,
  /** 板球大小 */
  Mty14004 = 14004,
  /** 板球大小 */
  Mty14005 = 14005,
  /** 板球单双 */
  Mty14006 = 14006,
  /** 板球在每队第一人出局前得分最高球队 */
  Mty14007 = 14007,
  /** 板球是否有加时 */
  Mty14008 = 14008,
  /** 板球是否有平局 */
  Mty14009 = 14009,
  /** 板球抛币获胜 */
  Mty14010 = 14010,
  /** 板球得四分最多的球队 */
  Mty14011 = 14011,
  /** 板球得六分最多的球队 */
  Mty14012 = 14012,
  /** 板球第X回合大小 */
  Mty14013 = 14013,
  /** 板球第X出局方式 */
  Mty14015 = 14015,
  /** 板球第X出局方式(6项) */
  Mty14016 = 14016,
  /** 板球得四分大小 */
  Mty14017 = 14017,
  /** 板球得六分大小 */
  Mty14018 = 14018,
  /** 板球主队得四分大小 */
  Mty14019 = 14019,
  /** 板球客队得四分大小 */
  Mty14020 = 14020,
  /** 板球主队得六分大小 */
  Mty14021 = 14021,
  /** 板球客队得六分大小 */
  Mty14022 = 14022,
  /** 板球三柱门大小 */
  Mty14023 = 14023,
  /** 板球额外分大小 */
  Mty14024 = 14024,
  /** 板球个人最高得分 */
  Mty14025 = 14025,
  /** 板球冠军赛事冠军 */
  Mty14998 = 14998,
  /** 板球冠军赛事冠军 */
  Mty14999 = 14999,
  /** CSGO 独赢（两项） */
  // Mty179001 = 179001,
  /** CSGO冠军赛事冠军 */
  Mty179999 = 179999,
  /** CSGO冠军赛事冠军 */
  Mty179998 = 179998,
  /** 自行车冠军赛事冠军 */
  Mty25999 = 25999,
  /** 自行车冠军赛事冠军 */
  Mty25998 = 25998,
  /** 飞镖让盘 */
  Mty20001 = 20001,
  /** 飞镖盘大小 */
  Mty20002 = 20002,
  /** 飞镖独赢（两项） */
  Mty20003 = 20003,
  /** 飞镖盘单双 */
  Mty20004 = 20004,
  /** 飞镖让局 */
  Mty20005 = 20005,
  /** 飞镖局大小 */
  Mty20006 = 20006,
  /** 飞镖盘独赢 */
  Mty20007 = 20007,
  /** 飞镖单双 */
  Mty20008 = 20008,
  /** 飞镖单局正确比分(BO5) */
  Mty20009 = 20009,
  /** 飞镖单局正确比分(BO7) */
  Mty20010 = 20010,
  /** 飞镖单局正确比分(BO9) */
  Mty20011 = 20011,
  /** 飞镖单局正确比分(BO11) */
  Mty20012 = 20012,
  /** 飞镖单局正确比分(BO12) */
  Mty20013 = 20013,
  /** 飞镖单局正确比分(BO13) */
  Mty20014 = 20014,
  /** 飞镖单局正确比分(BO15) */
  Mty20015 = 20015,
  /** 飞镖单局正确比分(BO17) */
  Mty20016 = 20016,
  /** 飞镖单局正确比分(BO19) */
  Mty20017 = 20017,
  /** 飞镖单局正确比分(BO21) */
  Mty20018 = 20018,
  /** 飞镖单节正确比分(BO3) */
  Mty20019 = 20019,
  /** 飞镖单节正确比分(BO5) */
  Mty20020 = 20020,
  /** 飞镖单节正确比分(BO7) */
  Mty20021 = 20021,
  /** 飞镖单节正确比分(BO9) */
  Mty20022 = 20022,
  /** 飞镖单节正确比分(BO11) */
  Mty20023 = 20023,
  /** 飞镖单节正确比分(BO13) */
  Mty20024 = 20024,
  /** 飞镖单节正确比分(BO15) */
  Mty20025 = 20025,
  /** 飞镖180分让分 */
  Mty20026 = 20026,
  /** 飞镖180分大小 */
  Mty20027 = 20027,
  /** 飞镖哪队选手180分更多 */
  Mty20028 = 20028,
  /** 飞镖主队180分大小 */
  Mty20029 = 20029,
  /** 飞镖客队180分大小 */
  Mty20030 = 20030,
  /** 飞镖第X个得180分的选手 */
  Mty20031 = 20031,
  /** 飞镖最高决胜镖的球员 */
  Mty20032 = 20032,
  /** 飞镖最高决胜镖大小 */
  Mty20033 = 20033,
  /** 飞镖170分结束比赛 */
  Mty20034 = 20034,
  /** 飞镖三合一 */
  Mty20035 = 20035,
  /** 飞镖比赛独赢&最高决胜镖 */
  Mty20036 = 20036,
  /** 飞镖比赛独赢&最多180分 */
  Mty20037 = 20037,
  /** 飞镖最高决胜镖&最多180分 */
  Mty20038 = 20038,
  /** 飞镖第X局独赢 */
  Mty20039 = 20039,
  /** 飞镖第X局大小 */
  Mty20040 = 20040,
  /** 飞镖第X局第Y次投掷最高得分球员 */
  Mty20041 = 20041,
  /** 飞镖第X局第Y次投掷得分范围 */
  Mty20042 = 20042,
  /** 飞镖第X局最高决胜镖颜色 */
  Mty20043 = 20043,
  /** 飞镖第X局最高决胜镖大小 */
  Mty20044 = 20044,
  /** 飞镖第X局最高决胜镖Y+ */
  Mty20045 = 20045,
  /** 飞镖第X局任一球员得180分 */
  Mty20046 = 20046,
  /** 飞镖第X局主队球员得180分 */
  Mty20047 = 20047,
  /** 飞镖第X局客队球员得180分 */
  Mty20048 = 20048,
  /** 飞镖冠军赛事冠军 */
  Mty20999 = 20999,
  /** 飞镖冠军赛事冠军 */
  Mty20998 = 20998,
  /** DOTA2冠军赛事冠军 */
  Mty164999 = 164999,
  /** DOTA2冠军赛事冠军 */
  Mty164998 = 164998,
  /** 电子篮球让分 */
  Mty178001 = 178001,
  /** 电子篮球大小分 */
  Mty178002 = 178002,
  /** 电子篮球独赢（2项 */
  Mty178003 = 178003,
  /** 电子篮球主队总分大小 */
  Mty178004 = 178004,
  /** 电子篮球客队总分大小 */
  Mty178005 = 178005,
  /** 电子篮球单双 */
  Mty178006 = 178006,
  /** 电子篮球独赢（三项） */
  Mty178007 = 178007,
  /** 电子篮球平局退款 */
  Mty178008 = 178008,
  /** 电子篮球独赢和大小 */
  Mty178009 = 178009,
  /** 电子篮球冠军赛事冠军 */
  Mty178999 = 178999,
  /** 电子篮球冠军赛事冠军 */
  Mty178998 = 178998,
  /** 电子足球让球 */
  Mty177001 = 177001,
  /** 电子足球大小球 */
  Mty177002 = 177002,
  /** 电子足球独赢(胜平负) */
  Mty177003 = 177003,
  /** 电子足球主队大小球 */
  Mty177004 = 177004,
  /** 电子足球客队大小球 */
  Mty177005 = 177005,
  /** 电子足球第X个进球 */
  Mty177006 = 177006,
  /** 电子足球单双 */
  Mty177007 = 177007,
  /** 电子足球剩余时间获胜 */
  Mty177008 = 177008,
  /** 电子足球平局退款 */
  Mty177009 = 177009,
  /** 电子足球主胜退款 */
  Mty177010 = 177010,
  /** 电子足球客胜退款 */
  Mty177011 = 177011,
  /** 电子足球双重机会 */
  Mty177012 = 177012,
  /** 电子足球足球欧盘让球 */
  Mty177013 = 177013,
  /** 电子足球主队精确进球数（选项0，1，2，3+） */
  Mty177014 = 177014,
  /** 电子足球客队精确进球数（选项0，1，2，3+） */
  Mty177015 = 177015,
  /** 电子足球足球主队是否获胜 */
  Mty177016 = 177016,
  /** 电子足球足球客队是否获胜 */
  Mty177017 = 177017,
  /** 电子足球任意球队获胜 */
  Mty177018 = 177018,
  /** 电子足球冠军赛事冠军 */
  Mty177999 = 177999,
  /** 电子足球冠军赛事冠军 */
  Mty177998 = 177998,
  /** 地板球冠军赛事冠军 */
  Mty10999 = 10999,
  /** 地板球冠军赛事冠军 */
  Mty10998 = 10998,
  /** F1赛车对垒赛 */
  Mty92001 = 92001,
  /** F1赛车大小 */
  Mty92000 = 92000,
  /** F1赛车冠军赛事冠军 */
  Mty92999 = 92999,
  /** F1赛车车手冠军 */
  Mty92998 = 92998,
  /** F1赛车车队冠军 */
  Mty92997 = 92997,
  /** 室内五人足球让球 */
  Mty17001 = 17001,
  /** 室内五人足球大小球 */
  Mty17002 = 17002,
  /** 室内五人足球独赢(胜平负) */
  Mty17003 = 17003,
  /** 室内五人足球平局退款 */
  Mty17004 = 17004,
  /** 室内五人足球单双 */
  Mty17005 = 17005,
  /** 室内五人足球双重机会 */
  Mty17006 = 17006,
  /** 室内五人足球双方均有进球 */
  Mty17007 = 17007,
  /** 室内五人足球剩余时间获胜 */
  Mty17008 = 17008,
  /** 室内五人足球第X个进球 */
  Mty17009 = 17009,
  /** 室内五人足球胜负 */
  Mty17010 = 17010,
  /** 室内五人足球主队大小球 */
  Mty17011 = 17011,
  /** 室内五人足球客队大小球 */
  Mty17012 = 17012,
  /** 五人足球冠军赛事冠军 */
  Mty17999 = 17999,
  /** 五人足球冠军赛事冠军 */
  Mty17998 = 17998,
  /** 高尔夫冠军赛事冠军 */
  Mty12999 = 12999,
  /** 高尔夫冠军赛事冠军 */
  Mty12998 = 12998,
  /** 手球让球 */
  Mty8001 = 8001,
  /** 手球大小 */
  Mty8002 = 8002,
  /** 手球主队大小 */
  Mty8003 = 8003,
  /** 手球客队大小 */
  Mty8004 = 8004,
  /** 手球胜平负 */
  Mty8005 = 8005,
  /** 手球平局退款 */
  Mty8006 = 8006,
  /** 手球单双 */
  Mty8007 = 8007,
  /** 手球胜负 */
  Mty8008 = 8008,
  /** 手球胜负 */
  Mty8010 = 8010,
  /** 手球冠军赛事冠军 */
  Mty8999 = 8999,
  /** 手球冠军赛事冠军 */
  Mty8998 = 8998,
  /** 冰球让球 */
  Mty2001 = 2001,
  /** 冰球大小球 */
  Mty2002 = 2002,
  /** 冰球胜平负 */
  Mty2003 = 2003,
  /** 冰球单双 */
  Mty2004 = 2004,
  /** 冰球主队大小球 */
  Mty2005 = 2005,
  /** 冰球客队大小球 */
  Mty2006 = 2006,
  /** 冰球胜负 */
  Mty2007 = 2007,
  /** 冰球胜分差 */
  Mty2008 = 2008,
  /** 冰球剩余时间获胜球队 */
  Mty2009 = 2009,
  /** 冰球第x粒进球 */
  Mty2010 = 2010,
  /** 冰球最后的进球 */
  Mty2011 = 2011,
  /** 冰球正确比分 */
  Mty2012 = 2012,
  /** 冰球比赛会有加时 */
  Mty2013 = 2013,
  /** 冰球最高得分节 */
  Mty2014 = 2014,
  /** 冰球双重机会 */
  Mty2015 = 2015,
  /** 冰球双重机会 */
  Mty2016 = 2016,
  /** 1x2 & Both Team To Score */
  Mty2020 = 2020,
  /** 冰球冠军赛事冠军 */
  Mty2999 = 2999,
  /** 冰球冠军赛事冠军 */
  Mty2998 = 2998,
  /** 冰球冠军赛事冠军 */
  Mty2997 = 2997,
  /** 冰球东部冠军 */
  Mty2996 = 2996,
  /** 冰球大都会赛区冠军 */
  Mty2995 = 2995,
  /** 冰球太平洋赛区冠军 */
  Mty2994 = 2994,
  /** 冰球中央赛区冠军 */
  Mty2993 = 2993,
  /** 冰球大西洋赛区冠军 */
  Mty2992 = 2992,
  /** 王者荣耀冠军赛事冠军 */
  Mty180999 = 180999,
  /** 王者荣耀冠军赛事冠军 */
  Mty180998 = 180998,
  /** LOL冠军赛事冠军 */
  Mty165999 = 165999,
  /** 英雄联盟冠军赛事冠军 */
  Mty165998 = 165998,
  /** 混合格斗大小 */
  Mty18001 = 18001,
  /** 混合格斗独赢（两项 */
  Mty18002 = 18002,
  /** 混合格斗是否会奋战到底 */
  Mty18003 = 18003,
  /** 混合格斗获胜方式 */
  Mty18004 = 18004,
  /** 格斗冠军赛事冠军 */
  Mty18999 = 18999,
  /** 格斗冠军赛事冠军 */
  Mty18998 = 18998,
  /** 摩托车赛动态冠军赛事玩法 */
  Mty95999 = 95999,
  /** 摩托车赛冠军赛事冠军 */
  Mty95998 = 95998,
  /** 奥林匹克冠军赛事冠军 */
  Mty100999 = 100999,
  /** 奥林匹克冠军赛事冠军 */
  Mty100998 = 100998,
  /** 奥林匹克冠军最多金牌 */
  Mty100997 = 100997,
  /** 奥林匹克冠军大多数奖牌 */
  Mty100996 = 100996,
  /** 橄榄球让球 */
  Mty4001 = 4001,
  /** 橄榄球大小 */
  Mty4002 = 4002,
  /** 橄榄球独赢(三项) */
  Mty4003 = 4003,
  /** 橄榄球平局退款 */
  Mty4004 = 4004,
  /** 橄榄球主队大小 */
  Mty4005 = 4005,
  /** 橄榄球客队大小 */
  Mty4006 = 4006,
  /** 橄榄球单双 */
  Mty4007 = 4007,
  /** 橄榄球晋级球队 */
  Mty4008 = 4008,
  /** 橄榄球冠军赛事冠军 */
  Mty4999 = 4999,
  /** 橄榄球冠军赛事冠军 */
  Mty4998 = 4998,
  /** 斯诺克让局数 */
  Mty16001 = 16001,
  /** 斯诺克局大小 */
  Mty16002 = 16002,
  /** 斯诺克独赢（两项） */
  Mty16003 = 16003,
  /** 斯诺克单局让分 */
  Mty16004 = 16004,
  /** 斯诺克单局大小分 */
  Mty16005 = 16005,
  /** 斯诺克单局独赢（两项） */
  Mty16006 = 16006,
  /** 斯诺克局数单双 */
  Mty16007 = 16007,
  /** 斯诺克最先赢得X局的选手 */
  Mty16008 = 16008,
  /** 斯诺克剩余时间获胜 */
  Mty16009 = 16009,
  /** 斯诺克是否会有决胜局 */
  Mty16010 = 16010,
  /** 斯诺克总分单双 */
  Mty16011 = 16011,
  /** 斯诺克最先获得X分的选手 */
  Mty16012 = 16012,
  /** 斯诺克单杆最高分选手 */
  Mty16013 = 16013,
  /** 斯诺克独赢（三项） */
  Mty16014 = 16014,
  /** 斯诺克是否有单杆得分50+ */
  Mty16015 = 16015,
  /** 斯诺克是否有单杆得分100+ */
  Mty16016 = 16016,
  /** 斯诺克前X局独赢（三项） */
  Mty16017 = 16017,
  /** 斯诺克是否会有犯规 */
  Mty16018 = 16018,
  /** 斯诺克打第X个球的选手 */
  Mty16019 = 16019,
  /** 斯诺克打最后球的选手 */
  Mty16020 = 16020,
  /** 斯诺克最后得分的类型 */
  Mty16021 = 16021,
  /** 斯诺克正确比分（BO5） */
  Mty16022 = 16022,
  /** 斯诺克正确比分（BO7） */
  Mty16023 = 16023,
  /** 斯诺克正确比分（BO9） */
  Mty16024 = 16024,
  /** 斯诺克正确比分（BO11） */
  Mty16025 = 16025,
  /** 斯诺克冠军赛事冠军 */
  Mty16999 = 16999,
  /** 斯诺克冠军赛事冠军 */
  Mty16998 = 16998,
  /** 足球让球 */
  Mty1000 = 1000,
  /** 足球欧盘让球 */
  Mty1002 = 1002,
  /** 足球独赢（胜平负） */
  Mty1005 = 1005,
  /** 足球平局退款 */
  Mty1006 = 1006,
  /** 足球亚盘大小球 */
  Mty1007 = 1007,
  /** 足球单双 */
  Mty1008 = 1008,
  /** 足球角球胜平负 */
  Mty1009 = 1009,
  /** 足球角球大小球 */
  Mty1010 = 1010,
  /** 足球角球让球 */
  Mty1011 = 1011,
  /** 足球双重机会 */
  Mty1012 = 1012,
  /** 足球角球数单双 */
  Mty1015 = 1015,
  /** 足球主胜退款 */
  Mty1016 = 1016,
  /** 足球客胜退款 */
  Mty1017 = 1017,
  /** 足球胜分差 */
  Mty1018 = 1018,
  /** 足球最后的进球 */
  Mty1019 = 1019,
  /** 足球主队大小球 */
  Mty1021 = 1021,
  /** 足球客队大小球 */
  Mty1022 = 1022,
  /** 足球主队零封对手 */
  Mty1025 = 1025,
  /** 足球客队零封对手 */
  Mty1026 = 1026,
  /** 足球双方均有进球 */
  Mty1027 = 1027,
  /** 足球哪支球队进球 */
  Mty1028 = 1028,
  /** 足球胜平负和大小 */
  Mty1030 = 1030,
  /** 足球独赢 & */
  Mty1031 = 1031,
  /** 足球胜平负和双方均有进球 */
  Mty1032 = 1032,
  /** 足球半场全场胜平负 */
  Mty1033 = 1033,
  /** 足球上/下半场均大于x */
  Mty1034 = 1034,
  /** 足球上/下半场均小于x */
  Mty1035 = 1035,
  /** 足球主队上/下半场均进球 */
  Mty1036 = 1036,
  /** 足球客队上/下半场均进球 */
  Mty1037 = 1037,
  /** 足球主队赢得所有半场 */
  Mty1038 = 1038,
  /** 足球主队赢得任一半场 */
  Mty1039 = 1039,
  /** 足球客队赢得所有半场 */
  Mty1040 = 1040,
  /** 足球客队赢得任一半场 */
  Mty1041 = 1041,
  /** 足球得分最高的半场 */
  Mty1042 = 1042,
  /** 足球主队得分最高的半场 */
  Mty1043 = 1043,
  /** 足球客队得分最高的半场 */
  Mty1044 = 1044,
  /** 足球晋级球队 */
  Mty1046 = 1046,
  /** 足球比赛结束形式 */
  Mty1047 = 1047,
  /** 足球比赛会有加时 */
  Mty1048 = 1048,
  /** 足球比赛会进球 */
  Mty1049 = 1049,
  /** 足球比赛会有点球大战 */
  Mty1050 = 1050,
  /** 足球第一个进球时间(15分钟以内) */
  Mty1051 = 1051,
  /** 足球最先达到x个角球球队 */
  Mty1054 = 1054,
  /** 足球最后的角球 */
  Mty1055 = 1055,
  /** 足球主队角球数大小 */
  Mty1057 = 1057,
  /** 足球客队角球数大小 */
  Mty1058 = 1058,
  /** 足球得牌让牌 */
  Mty1060 = 1060,
  /** 足球得牌胜平负 */
  Mty1061 = 1061,
  /** 足球罚牌大小 */
  Mty1063 = 1063,
  /** 足球主队罚牌大小 */
  Mty1065 = 1065,
  /** 足球客队罚牌大小 */
  Mty1066 = 1066,
  /** 足球黄牌让牌 */
  Mty1067 = 1067,
  /** 足球黄牌大小 */
  Mty1068 = 1068,
  /** 足球黄牌胜平负 */
  Mty1069 = 1069,
  /** 足球罚牌时间 */
  Mty1070 = 1070,
  /** 足球是否有球员被罚下 */
  Mty1072 = 1072,
  /** 足球主队有球员罚下 */
  Mty1073 = 1073,
  /** 足球客队有球员罚下 */
  Mty1074 = 1074,
  /** 足球第几个进球的球员 */
  Mty1075 = 1075,
  /** 足球任何时间进球的球员 */
  Mty1076 = 1076,
  /** 足球最后一个进球的球员 */
  Mty1077 = 1077,
  /** 足球双重机会和大小 */
  Mty1078 = 1078,
  /** 足球双重机会和双方均有进球 */
  Mty1079 = 1079,
  /** 足球波胆多重选择 */
  Mty1080 = 1080,
  /** 足球主队单双 */
  Mty1082 = 1082,
  /** 足球客队单双 */
  Mty1083 = 1083,
  /** 足球紅牌让牌 */
  Mty1086 = 1086,
  /** 足球紅牌大小 */
  Mty1087 = 1087,
  /** 足球紅牌胜平负 */
  Mty1088 = 1088,
  /** 足球第几个进球球队 */
  Mty1089 = 1089,
  /** 足球剩余时间获胜球队 */
  Mty1090 = 1090,
  /** 足球主队获胜 */
  Mty1091 = 1091,
  /** 足球客队获胜 */
  Mty1092 = 1092,
  /** 足球任意球队获胜 */
  Mty1093 = 1093,
  /** 足球第x个角球 */
  Mty1094 = 1094,
  /** 足球上下半场双方是否进球 */
  Mty1097 = 1097,
  /** 足球点球大战获胜球队 */
  Mty1098 = 1098,
  /** 足球足球波胆（任意球队进球大于等于5判定选项”其他“赢） */
  Mty1099 = 1099,
  /** 足球波胆（任意球队进球大于等于3判定选项”其他“赢） */
  Mty1100 = 1100,
  /** 足球进球范围（选项0-1， 2-3，4-6，7+） */
  Mty1101 = 1101,
  /** 足球精确进球数（选项0，1，2，3，4，5，6+） */
  Mty1102 = 1102,
  /** 足球精确进球数（选项0，1，2，3+） */
  Mty1103 = 1103,
  /** 足球精确进球数（选项0，1，2+） */
  Mty1104 = 1104,
  /** 足球主队精确进球数（选项0，1，2，3+） */
  Mty1105 = 1105,
  /** 足球客队精确进球数（选项0，1，2，3+） */
  Mty1106 = 1106,
  /** 足球角球范围（选项 0-8，9-11，12+） */
  Mty1107 = 1107,
  /** 足球角球范围（选项 0-4，5-6，7+） */
  Mty1108 = 1108,
  /** 足球主队角球范围（选项0-2，3-4，5-6，7+） */
  Mty1109 = 1109,
  /** 足球客队角球范围（选项0-2，3-4，5-6，7+） */
  Mty1110 = 1110,
  /** 足球波胆（选项中任意球队进球小于等于9） */
  Mty1111 = 1111,
  /** 足球主队精确进球数（选项0，1，2，3，4+） */
  Mty1112 = 1112,
  /** 足球客队精确进球数（选项0，1，2，3，4+） */
  Mty1113 = 1113,
  /** 足球获胜方法 */
  Mty1114 = 1114,
  /** 足球大小&两队均进球 */
  Mty1115 = 1115,
  /** 足球球员是否进球 */
  Mty1116 = 1116,
  /** 足球进球方式 */
  Mty1118 = 1118,
  /** 足球获得冠军 */
  Mty1119 = 1119,
  /** 足球获得季军 */
  Mty1120 = 1120,
  /** 足球点球波胆 */
  Mty1123 = 1123,
  /** 足球获胜 & */
  Mty1124 = 1124,
  /** 足球精确进球数（选项0-4，5，6，7，8，9，10+） */
  Mty1125 = 1125,
  /** 足球得牌单双 */
  Mty1126 = 1126,
  /** 足球哪队开球 */
  Mty1127 = 1127,
  /** 足球第x个点球是否进球 */
  Mty1128 = 1128,
  /** 足球点球阶段胜分差 */
  Mty1129 = 1129,
  /** 足球主队第一个点球是否进球 */
  Mty1130 = 1130,
  /** 足球客队第一个点球是否进球 */
  Mty1131 = 1131,
  /** 足球主队第二个点球是否进球 */
  Mty1132 = 1132,
  /** 足球客队第二个点球是否进球 */
  Mty1133 = 1133,
  /** 足球主队第三个点球是否进球 */
  Mty1134 = 1134,
  /** 足球客队第三个点球是否进球 */
  Mty1135 = 1135,
  /** 足球主队第四个点球是否进球 */
  Mty1136 = 1136,
  /** 足球客队第四个点球是否进球 */
  Mty1137 = 1137,
  /** 足球主队第五个点球是否进球 */
  Mty1138 = 1138,
  /** 足球客队第五个点球是否进球 */
  Mty1139 = 1139,
  /** 足球点球第一回合胜平负 */
  Mty1140 = 1140,
  /** 足球点球第二回合胜平负 */
  Mty1141 = 1141,
  /** 足球点球第三回合胜平负 */
  Mty1142 = 1142,
  /** 足球点球第四回合胜平负 */
  Mty1143 = 1143,
  /** 足球点球第五回合胜平负 */
  Mty1144 = 1144,
  /** 足球点球结束的回合 */
  Mty1145 = 1145,
  /** 足球第一个角球（两项） */
  Mty1146 = 1146,
  /** 足球最后一个角球（两项） */
  Mty1147 = 1147,
  /** 足球第一个得牌 */
  Mty1148 = 1148,
  /** 足球最后一个得牌 */
  Mty1149 = 1149,
  /** 足球第一个换人 */
  Mty1150 = 1150,
  /** 足球最后一个换人 */
  Mty1151 = 1151,
  /** 足球第一个球门球 */
  Mty1152 = 1152,
  /** 足球最后一个球门球 */
  Mty1153 = 1153,
  /** 足球第一个越位 */
  Mty1154 = 1154,
  /** 足球最后一个越位 */
  Mty1155 = 1155,
  /** 足球第一个界外球 */
  Mty1156 = 1156,
  /** 足球最后一个界外球 */
  Mty1157 = 1157,
  /** 足球第一个任意球 */
  Mty1158 = 1158,
  /** 足球最后一个任意球 */
  Mty1159 = 1159,
  /** 足球角球最高得分半场 */
  Mty1160 = 1160,
  /** 足球角球最高得分半场(两项) */
  Mty1161 = 1161,
  /** 足球最高得分半场让分 */
  Mty1162 = 1162,
  /** 足球是否有乌龙球 */
  Mty1163 = 1163,
  /** 足球常规时间是否判罚第一个点球 */
  Mty1164 = 1164,
  /** 足球常规时间判罚的第一个点球是否打进 */
  Mty1165 = 1165,
  /** 足球哪队会反超获胜 */
  Mty1166 = 1166,
  /** 足球主队零失球获胜 */
  Mty1167 = 1167,
  /** 足球客队零失球获胜 */
  Mty1168 = 1168,
  /** 足球第几个得牌 */
  Mty1169 = 1169,
  /** 足球精确得牌（12+） */
  Mty1170 = 1170,
  /** 足球主队精确得牌（4+） */
  Mty1171 = 1171,
  /** 足球客队精确得牌（4+） */
  Mty1172 = 1172,
  /** 足球精确得牌（6+） */
  Mty1173 = 1173,
  /** 足球主队精确得牌（3+） */
  Mty1174 = 1174,
  /** 足球客队精确得牌（3+） */
  Mty1175 = 1175,
  /** 足球第一个进球发生在哪个半场 */
  Mty1176 = 1176,
  /** 足球主队第一个进球发生在哪个半场 */
  Mty1177 = 1177,
  /** 足球客队第一个进球发生在哪个半场 */
  Mty1178 = 1178,
  /** 足球哪支球队踢第一个点球 */
  Mty1179 = 1179,
  /** 足球是否进行点球骤死赛 */
  Mty1180 = 1180,
  /** 足球点球第一个回合踢中门柱 */
  Mty1181 = 1181,
  /** 足球点球第二个回合踢中门柱 */
  Mty1182 = 1182,
  /** 足球点球第三个回合踢中门柱 */
  Mty1183 = 1183,
  /** 足球点球第四个回合踢中门柱 */
  Mty1184 = 1184,
  /** 足球点球第五个回合踢中门柱 */
  Mty1185 = 1185,
  /** 足球半/全场正确比分 */
  Mty1186 = 1186,
  /** 足球冠军赛事动态玩法 */
  Mty1999 = 1999,
  /** 足球冠军赛事胜者 */
  Mty1998 = 1998,
  /** 足球冠军赛事A组前2名球队 */
  Mty1997 = 1997,
  /** 足球冠军赛事A组前两名球队 */
  Mty1996 = 1996,
  /** 足球冠军赛事A组前两名球队 */
  Mty1995 = 1995,
  /** 足球冠军赛事A组前6名球队 */
  Mty1994 = 1994,
  /** 足球冠军赛事A组前8名球队 */
  Mty1993 = 1993,
  /** 足球冠军赛事跻身前半部分球队 */
  Mty1992 = 1992,
  /** 足球冠军赛事跻身后半部分球队 */
  Mty1991 = 1991,
  /** 足球冠军赛事降级球队 */
  Mty1990 = 1990,
  /** 足球冠军赛事晋级球队 */
  Mty1989 = 1989,
  /** 足球冠军赛事A组胜者 */
  Mty1988 = 1988,
  /** 足球冠军赛事B组胜者 */
  Mty1987 = 1987,
  /** 足球冠军赛事C组胜者 */
  Mty1986 = 1986,
  /** 足球冠军赛事D组胜者 */
  Mty1985 = 1985,
  /** 足球冠军赛事E组胜者 */
  Mty1984 = 1984,
  /** 足球冠军赛事F组胜者 */
  Mty1983 = 1983,
  /** 足球冠军赛事G组胜者 */
  Mty1982 = 1982,
  /** 足球冠军赛事H组胜者 */
  Mty1981 = 1981,
  /** 足球冠军赛事I组胜者 */
  Mty1968 = 1968,
  /** 足球冠军赛事J组胜者 */
  Mty1967 = 1967,
  /** 足球冠军赛事A组前两名球队 */
  Mty1980 = 1980,
  /** 足球冠军赛事B组前两名球队 */
  Mty1979 = 1979,
  /** 足球冠军赛事C组前两名球队 */
  Mty1978 = 1978,
  /** 足球冠军赛事D组前两名球队 */
  Mty1977 = 1977,
  /** 足球冠军赛事E组前两名球队 */
  Mty1976 = 1976,
  /** 足球冠军赛事F组前两名球队 */
  Mty1975 = 1975,
  /** 足球冠军赛事G组前两名球队 */
  Mty1974 = 1974,
  /** 足球冠军赛事H组前两名球队 */
  Mty1973 = 1973,
  /** 足球冠军赛事I组前两名球队 */
  Mty1966 = 1966,
  /** 足球冠军赛事J组前两名球队 */
  Mty1965 = 1965,
  /** 足球冠军赛事进入四分之一决赛球队 */
  Mty1972 = 1972,
  /** 足球冠军赛事进入半决赛球队 */
  Mty1971 = 1971,
  /** 足球冠军赛事垫底球队 */
  Mty1970 = 1970,
  /** 足球冠军赛事最高得分球员 */
  Mty1969 = 1969,
  /** 特殊投注赛事冠军 */
  Mty93999 = 93999,
  /** 特殊投注冠军赛事冠军 */
  Mty93998 = 93998,
  /** 特殊投注最佳男演员(奥斯卡) */
  Mty93997 = 93997,
  /** 特殊投注最佳女演员(奥斯卡) */
  Mty93996 = 93996,
  /** 特殊投注最佳动画电影（奥斯卡） */
  Mty93995 = 93995,
  /** 特殊投注最佳摄影（奥斯卡） */
  Mty93994 = 93994,
  /** 特殊投注最佳服装设计（奥斯卡） */
  Mty93993 = 93993,
  /** 特殊投注最佳导演（奥斯卡） */
  Mty93992 = 93992,
  /** 特殊投注最佳纪录片（奥斯卡） */
  Mty93991 = 93991,
  /** 特殊投注最佳影片剪辑（奥斯卡） */
  Mty93990 = 93990,
  /** 特殊投注最佳国际剧情片（奥斯卡） */
  Mty93989 = 93989,
  /** 特殊投注最佳化妆发型（奥斯卡） */
  Mty93988 = 93988,
  /** 特殊投注最佳音乐-原创乐谱（奥斯卡） */
  Mty93987 = 93987,
  /** 特殊投注最佳音乐-原创歌曲（奥斯卡） */
  Mty93986 = 93986,
  /** 特殊投注最佳影片（奥斯卡） */
  Mty93985 = 93985,
  /** 特殊投注最佳艺术指导（奥斯卡） */
  Mty93984 = 93984,
  /** 特殊投注最佳音响（奥斯卡） */
  Mty93983 = 93983,
  /** 特殊投注最佳女配角（奥斯卡） */
  Mty93982 = 93982,
  /** 特殊投注最佳视觉效果奖（奥斯卡） */
  Mty93981 = 93981,
  /** 特殊投注最佳编剧-改编剧本（奥斯卡） */
  Mty93980 = 93980,
  /** 特殊投注最佳编剧-原创剧本（奥斯卡） */
  Mty93979 = 93979,
  /** 特殊投注最佳男演员（英国电影学院） */
  Mty93978 = 93978,
  /** 特殊投注最佳女演员（英国电影学院） */
  Mty93977 = 93977,
  /** 特殊投注最佳导演（英国电影学院） */
  Mty93976 = 93976,
  /** 特殊投注最佳影片（英国电影学院） */
  Mty93975 = 93975,
  /** 特殊投注最佳男配角（英国电影学院） */
  Mty93974 = 93974,
  /** 特殊投注最佳女配角（英国电影学院） */
  Mty93973 = 93973,
  /** 特殊投注英国杰出电影（英国电影学院） */
  Mty93972 = 93972,
  /** 赛车动态冠军赛事玩法 */
  Mty94999 = 94999,
  /** 赛车冠军赛事冠军 */
  Mty94998 = 94998,
  /** 乒乓球独赢（两项） */
  Mty15001 = 15001,
  /** 乒乓球让分 */
  Mty15002 = 15002,
  /** 乒乓球大小分 */
  Mty15003 = 15003,
  /** 乒乓球正确比分(BO5) */
  Mty15004 = 15004,
  /** 乒乓球正确比分(BO7) */
  Mty15005 = 15005,
  /** 乒乓球单双 */
  Mty15006 = 15006,
  /** 乒乓球单局独赢（两项） */
  Mty15008 = 15008,
  /** 乒乓球冠军赛事冠军 */
  Mty15999 = 15999,
  /** 乒乓球冠军赛事冠军 */
  Mty15998 = 15998,
  /** 网球独赢（两项） */
  Mty5001 = 5001,
  /** 网球让局 */
  Mty5002 = 5002,
  /** 网球总局数 */
  Mty5003 = 5003,
  /** 网球让盘 */
  Mty5004 = 5004,
  /** 网球总盘数 */
  Mty5005 = 5005,
  /** 网球正确比分(BO3) */
  Mty5006 = 5006,
  /** 网球正确比分(BO5) */
  Mty5007 = 5007,
  /** 网球选手1总局数 */
  Mty5008 = 5008,
  /** 网球选手2总局数 */
  Mty5009 = 5009,
  /** 网球局数单双 */
  Mty5010 = 5010,
  /** 网球正确盘分 */
  Mty5011 = 5011,
  /** 网球盘独赢 */
  Mty5012 = 5012,
  /** 网球第几局胜者 */
  Mty5013 = 5013,
  /** 网球是否会有抢七 */
  Mty5014 = 5014,
  /** 网球第一盘/整场比赛胜负 */
  Mty5015 = 5015,
  /** 网球主队赢一盘 */
  Mty5016 = 5016,
  /** 网球客队赢一盘 */
  Mty5017 = 5017,
  /** 网球独赢&大小 */
  Mty5018 = 5018,
  /** 网球冠军赛事冠军 */
  Mty5999 = 5999,
  /** 网球冠军赛事冠军 */
  Mty5998 = 5998,
  /** 虚拟足球独赢 */
  Mty1001003 = 1001003,
  /** 虚拟足球半/全场 */
  Mty1001015 = 1001015,
  /** 虚拟足球双重机会 */
  Mty1001004 = 1001004,
  /** 虚拟足球波胆（Max6） */
  Mty1001006 = 1001006,
  /** 虚拟足球精确进球数（Max6） */
  Mty1001007 = 1001007,
  /** 虚拟足球双方都进球 */
  Mty1001008 = 1001008,
  /** 虚拟足球大/小 */
  Mty1001002 = 1001002,
  /** 虚拟足球独赢 & */
  Mty1001016 = 1001016,
  /** 虚拟足球进球区间（多项） */
  Mty1001011 = 1001011,
  /** 虚拟足球让球 */
  Mty1001001 = 1001001,
  /** 虚拟足球欧盘让球 */
  Mty1001005 = 1001005,
  /** 虚拟足球主队进球区间 */
  Mty1001012 = 1001012,
  /** 虚拟足球客队进球区间 */
  Mty1001013 = 1001013,
  /** 虚拟足球波胆（Max3） */
  Mty1001010 = 1001010,
  /** 虚拟足球单双 */
  Mty1001009 = 1001009,
  /** 虚拟足球胜分差 */
  Mty1001014 = 1001014,
  /** 虚拟赛马冠军 */
  Mty1020001 = 1020001,
  /** 虚拟赛马前二 */
  Mty1020002 = 1020002,
  /** 虚拟赛马前三 */
  Mty1020003 = 1020003,
  /** 前二组合 */
  Mty1020004 = 1020004,
  /** 准确前二 */
  Mty1020005 = 1020005,
  /** 大小 */
  Mty1020006 = 1020006,
  /** 单双 */
  Mty1020007 = 1020007,
  /** 虚拟赛狗冠军 */
  Mty1021001 = 1021001,
  /** 虚拟赛狗前二 */
  Mty1021002 = 1021002,
  /** 虚拟赛狗前三 */
  Mty1021003 = 1021003,
  /** 前二组合 */
  Mty1021004 = 1021004,
  /** 准确前二 */
  Mty1021005 = 1021005,
  /** 大小 */
  Mty1021006 = 1021006,
  /** 单双 */
  Mty1021007 = 1021007,
  /** 虚拟沙地摩托冠军 */
  Mty1022001 = 1022001,
  /** 虚拟沙地摩托前二 */
  Mty1022002 = 1022002,
  /** 虚拟沙地摩托前三 */
  Mty1022003 = 1022003,
  /** 前二组合 */
  Mty1022004 = 1022004,
  /** 准确前二 */
  Mty1022005 = 1022005,
  /** 大小 */
  Mty1022006 = 1022006,
  /** 单双 */
  Mty1022007 = 1022007,
  /** 虚拟摩托冠军 */
  Mty1023001 = 1023001,
  /** 虚拟摩托前二 */
  Mty1023002 = 1023002,
  /** 虚拟摩托前三 */
  Mty1023003 = 1023003,
  /** 前二组合 */
  Mty1023004 = 1023004,
  /** 准确前二 */
  Mty1023005 = 1023005,
  /** 大小 */
  Mty1023006 = 1023006,
  /** 单双 */
  Mty1023007 = 1023007,
  /** 排球独赢（两项） */
  Mty13001 = 13001,
  /** 排球让分 */
  Mty13002 = 13002,
  /** 排球大小分 */
  Mty13003 = 13003,
  /** 排球正确比分(BO5) */
  Mty13004 = 13004,
  /** 排球正确比分(BO7) */
  Mty13005 = 13005,
  /** 排球局独赢 */
  Mty13006 = 13006,
  /** 排球单双 */
  Mty13007 = 13007,
  /** 排球冠军赛事冠军 */
  Mty13999 = 13999,
  /** 排球冠军赛事冠军 */
  Mty13998 = 13998,
  /** 水球大小 */
  Mty24001 = 24001,
  /** 水球独赢 */
  Mty24002 = 24002,
  /** 水球让球 */
  Mty24003 = 24003,
  /** 水球冠军赛事冠军 */
  Mty24999 = 24999,
  /** 水球冠军赛事冠军 */
  Mty24998 = 24998,
  Mty177019 = 177019,
  Mty177020 = 177020,
  Mty177021 = 177021,
  Mty177022 = 177022,
  Mty177023 = 177023,
  Mty177024 = 177024,
  Mty177025 = 177025,
  Mty177026 = 177026,
  Mty177027 = 177027,
  Mty177028 = 177028,
  Mty177029 = 177029,
  Mty177031 = 177031,
  Mty177032 = 177032,
  Mty178010 = 178010,
  Mty178011 = 178011,
  Mty7020 = 7020,

  /** doda2 全局获胜 */
  Mty164001 = 164001,
  /** doda2 地图让分 */
  Mty164002 = 164002,
  /** doda2 地图大小 */
  Mty164003 = 164003,
  Mty164004 = 164004,
  Mty164005 = 164005,
  Mty164006 = 164006,
  Mty164007 = 164007,
  Mty164008 = 164008,

  /** lol 全局获胜 */
  Mty165001 = 165001,
  /** lol 地图让分 */
  Mty165002 = 165002,
  /** lol 地图大小 */
  Mty165003 = 165003,
  Mty165004 = 165004,
  Mty165005 = 165005,
  Mty165006 = 165006,
  Mty165007 = 165007,
  Mty165008 = 165008,

  /** 无畏契约 全局获胜 */
  Mty169001 = 169001,
  /** 无畏契约 地图让分 */
  Mty169002 = 169002,
  /** 无畏契约 地图大小 */
  Mty169003 = 169003,
  Mty169004 = 169004,
  Mty169005 = 169005,
  Mty169006 = 169006,
  Mty169007 = 169007,
  Mty169008 = 169008,
  Mty169011 = 169011,

  /** csgo 全局获胜 */
  Mty179001 = 179001,
  /** csgo 地图让分 */
  Mty179002 = 179002,
  /** csgo 地图大小 */
  Mty179003 = 179003,
  Mty179004 = 179004,
  Mty179005 = 179005,
  Mty179006 = 179006,
  Mty179007 = 179007,
  Mty179008 = 179008,
  Mty179011 = 179011,

  /** 王者荣耀 全局获胜 */
  Mty180001 = 180001,
  /** 王者荣耀 地图让分 */
  Mty180002 = 180002,
  /** 王者荣耀 地图大小 */
  Mty180003 = 180003,
  Mty180004 = 180004,
  Mty180005 = 180005,
  Mty180006 = 180006,
  Mty180007 = 180007,
  Mty180008 = 180008,

  Mty1190 = 1190,
}
